import type { ReactNode } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { OpsRequestQueue } from '../components/features/ops/OpsRequestQueue.js';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Operations
 * @graph-business ops のシステム運用タブ。#fatal / #daily_toils などのアラートから自動起票されるシステムオペレーション（scope=system）だけを、キューと同じ表（ID / 起票 / 緊急度 / 対応者 / 進捗 / 依頼。SLO は対象外なので列を出さない）で一覧する。ステータス（All / Open / Investigating / Blocked / Closed）・サービス絞り込み・検索・並び替え・スクロール読み込みはキューと共通。依頼者のいる依頼とは分け、キュー・SLO / KPI には含めない
 * @graph-connects OpsRequestQueue [calls] 対象範囲 system で一覧（ステータスタブ・サービス絞り込み・検索・並び替え）を描画
 */
export const Route = createFileRoute('/ops/system')({
  component: OpsSystemPage,
});

/** @graph-connects OpsRequestQueue [calls] 対象範囲 system の一覧 */
function OpsSystemPage(): ReactNode {
  return <OpsRequestQueue scope="system" />;
}
